

    import { useI18n } from 'vue-i18n';
  import * as yup from 'yup';

  import type { CustomFieldOrderDataEntry } from '@/types';

  function getRulesString (customField: CustomFieldOrderDataEntry, required?: boolean, fieldlistValues?: string[] | null, charLimit?: number, onlyNumbers?: boolean) {
    let rules: yup.StringSchema;
    const { t } = useI18n();
    rules = yup.string();


    if (charLimit) {
      rules = rules.matches(new RegExp(`^.{0,${charLimit}}$`), t('validation.char_limit', { limit: charLimit }));
    }
    if (onlyNumbers) {
      rules = rules.matches(/^\d*$/, t('validation.number'));
    }
    if (required) {
      // cannot be empty string
      rules = rules.matches(/^(?!\s*$).+/, t('validation.required'));
      rules = rules.notOneOf([''], t('validation.required'));
      //checkbox must be 'on'
      if (customField.fieldType === 'checkbox' ){
        rules = rules.notOneOf(['off'], t('validation.required'));
      } 

      if (customField.fieldType === 'cprnumber') {
        rules = rules.matches(/^\d{6}-?\d{4}$/, t('validation.cpr'));
        rules = rules.test('cpr-checksum', t('validation.cpr'), (value) => {
          if (!value) return true;
          const digits = value.replace(/-/g, '');
          if (!/^\d{10}$/.test(digits)) return true; // format error already caught above
          const weights = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
          const sum = weights.reduce((acc, w, i) => acc + w * parseInt(digits[i]), 0);
          return sum % 11 === 0;
        });
      }

      
    }
    if(fieldlistValues && fieldlistValues.length > 0){
      const validFieldListValues: string[] = [...fieldlistValues];
      if(!required){
        validFieldListValues.push('');
        validFieldListValues.push("");
      }
      rules = rules.oneOf(validFieldListValues, t('validation.invalid_option'));
    }

    return rules;
  };
  
  function getRulesNumber () {
    const { t } = useI18n();
    let rules: yup.NumberSchema;
    rules = yup.number();
    rules = yup.number().typeError(t('validation.number'));

    return rules;
  };

  function getRulesBoolean (required?: boolean) {
    const { t } = useI18n();
    let rules: yup.BooleanSchema;
    rules = yup.boolean();
    if (required) {
      rules = rules.oneOf([true], t('validation.required'));
    }

    return rules;
  };

  function getRulesSharedAll (rules: yup.NumberSchema | yup.StringSchema | yup.BooleanSchema, required?: boolean) {

    const { t } = useI18n();
    if (required) {
      rules = rules.required(t('validation.required'));
      rules = rules.defined(t('validation.required'));
      rules = rules.nonNullable(t('validation.required'));
    }

    return rules;
  };

  function getRulesSharedStringNumber (rules: yup.NumberSchema | yup.StringSchema) {
    return rules;
  };

 export function getRules (customField: CustomFieldOrderDataEntry, type: string, required?: boolean, fieldlistValues?: string[] | null, charLimit?: number, onlyNumbers?: boolean){
    let rules;

    if (!customField) {
      return undefined;
    }
    if(!type){
      return undefined;
    }
    // Type rules here
    if(type == 'string'){
      rules = yup.StringSchema;
      rules = yup.string();
      rules = getRulesString(customField, required, fieldlistValues, charLimit, onlyNumbers);
      rules = getRulesSharedStringNumber(rules);
    }
    else if(type == 'number'){
      rules = yup.NumberSchema;
      rules = getRulesNumber();
      rules = getRulesSharedStringNumber(rules);
    }
    else if(type == 'boolean'){
      rules = yup.BooleanSchema;
      rules = getRulesBoolean(required);
    }
    else {
      return undefined;
    }
    rules = getRulesSharedAll(rules, required);
    // Keep this in case we need it later
    /*else {
      rules = yup.string();
      if (customField.fieldType === 'email') {
        rules = rules.email(t('validation.email'));
      }
      if (customField.fieldType === 'tel') {
        rules = rules.matches(/^\+?[0-9\s-]+$/, t('validation.phone'));
      }
      if (customField.fieldType === 'cprnumber') {
        rules = rules.matches(/^\d{6}-?\d{4}$/, t('validation.cpr'));
      }
    }*/

    return rules;
  };